import React from 'react';
import type { OperationDefinitionDto } from '../../types';
import { domainLabel, riskLabel } from './utils.tsx';

interface Props {
    definitions: OperationDefinitionDto[];
    selectedDefinition: OperationDefinitionDto | null;
    onSelectOperation: (definition: OperationDefinitionDto) => void;
}

const OperationsDefinitionList: React.FC<Props> = ({ definitions, selectedDefinition, onSelectOperation }) => (
    <>
        <h2>Каталог операций</h2>
        {definitions.length > 0 ? (
            <div className="operations-definition-list">
                {definitions.map(def => (
                    <div
                        className={`operations-definition ${selectedDefinition?.code === def.code ? 'operations-definition-active' : ''}`}
                        key={def.code}
                        onClick={() => onSelectOperation(def)}
                    >
                        <div className="operations-definition-header">
                            <h3>{def.title}</h3>
                            <span className="operations-domain-tag">{domainLabel[def.domain] ?? def.domain}</span>
                        </div>
                        <p>{def.description}</p>
                        <div className="operations-definition-meta">
                            <span className={`operations-risk risk-${def.riskLevel.toLowerCase()}`}>
                                Риск: {riskLabel[def.riskLevel] ?? def.riskLevel}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <div className="operations-empty">Операции не найдены.</div>
        )}
    </>
);

export default OperationsDefinitionList;
